import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
// Mirrors the private field names on each ActivityLog*EntryModel subclass that serialize to JSON.
// Guarded by the `serialized DTO-alias key contract` tests — rename a private field, fail a test.
const INFRA_ID_KEYS = new Set([
    'dto',
    'agreementDTO',
    'serviceDTO',
    'chargeDTO',
    'invoiceDTO',
    'businessDTO'
]);
const stripInfraIds = (entries)=>{
    if (!Array.isArray(entries)) return entries;
    return entries.map((entry)=>{
        const next = _object_spread({}, entry);
        for (const key of INFRA_ID_KEYS){
            const value = next[key];
            if (value == null || typeof value !== 'object') continue;
            const { id: _id } = value, rest = _object_without_properties(value, [
                "id"
            ]);
            next[key] = rest;
        }
        return next;
    });
};
const toComparable = (value)=>stripInfraIds(JSON.parse(JSON.stringify(value)));
const withoutSentNotifications = (entries)=>entries.filter((entry)=>!entry.isSentNotificationEntry());
export const diffActivityLogs = (oldResult, newResult)=>{
    const filteredOld = withoutSentNotifications(oldResult);
    const filteredNew = withoutSentNotifications(newResult);
    if (JSON.stringify(toComparable(filteredOld)) === JSON.stringify(toComparable(filteredNew))) {
        return null;
    }
    return {
        kind: 'mismatch',
        oldLength: filteredOld.length,
        newLength: filteredNew.length
    };
};
export const buildDiffPayload = (args)=>({
        relationshipId: args.relationshipId,
        ffOpen: args.ffOpen,
        diff: args.diff,
        oldResult: args.oldResult,
        newResult: args.newResult,
        timestamp: args.timestamp
    });
